	import { ChangeEvent, useCallback, useState } from "react";
import { getCustomerList } from "src/apis/customerApi";
import { getBankacctList } from "src/apis/bankacctApi";
import { DropDownForm } from "src/components/common/form/DropdownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";


import { BRDiv } from "src/components/common/common";
import { RadioButtonForm } from "src/components/common/form/checkbox/RadioButtonForm";
import { CodeForm } from "src/components/common/form/CodeForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";
import { defaultPUR6010_R01HeaderDto, PUR6010_R01HeaderDto } from "./Dto_PUR6010_R01";
import { usePUR6010_R01Store, noteCreateFlgMap_PUR6010_R01 } from "./Store_PUR6010_R01";
import { formatDate } from "src/utils/string/stringUtil";
import { getEmployeeList } from "src/apis/employeeApi";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { getCompanyList } from "src/apis/companyApi";



interface Props {
	defaultPUR6010_R01HeaderRow: PUR6010_R01HeaderDto;
}

export const Info_PUR6010_R01 = (props: Props) => {

	const { defaultPUR6010_R01HeaderRow } = props;

	// 
	const { compCdList, bankCdList } = useCommonCodeStore();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { editPUR6010_R01, setEditPUR6010_R01,
			// selectedPUR6010_R01,
			// setDetailCreateTrigger,
	} = usePUR6010_R01Store();

	// const prevCustomCdRef = useRef<string>('');

	const compInfoHandleFoucsId = 'infoCompInput';
	const custInfoHandleFoucsId = 'infoCustInput';
	const empInfoHandleFoucsId = 'infoEmpInput';
	const bankAcctInfoHandleFoucsId = 'infoBankAcctInput';

	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
				telNo: 'telNo',
				faxNo: 'faxNo',
				moneyCd: 'moneyCd'
			},
			searchFunction: async (code: string) => {
				const customerResponse = await getCustomerList('all');
				return customerResponse.data.data.find(value => value.customCd === code);
			},
			extraFilter: () => ({
				customCd: editPUR6010_R01?.customCd || '',
				customNm: editPUR6010_R01?.customNm || '',
			}),
		},
		{
			fieldName: 'compCd',
			category: '사업장',
			focusId: compInfoHandleFoucsId,
			responseMapping: {
				compCd: 'compCd',
				compNm: 'compNm',
			},
			searchFunction: async (code: string) => {
				const companyResponse = await getCompanyList('all');
				return companyResponse.data.data.find(value => value.compCd === code);
			},
			extraFilter: () => ({
				compCd: editPUR6010_R01?.compCd || '',
				compNm: editPUR6010_R01?.compNm || '',
			}),
		},
		{
			fieldName: 'empNo',
			category: '담당자',
			focusId: empInfoHandleFoucsId,
			responseMapping: {
				empNo: 'empNo',
				empNm: 'empNm'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList('all');
				return employeeResponse.data.data.find(value => value.empNo === code);
			},
			extraFilter: () => ({
				empNo: editPUR6010_R01?.empNo || '',
				empNm: editPUR6010_R01?.empNm || '',
			}),
		},
		{
			fieldName: 'bankAcctNo',
			category: '계좌번호',
			focusId: bankAcctInfoHandleFoucsId,
			responseMapping: {
				bankAcctNo: 'bankAcctNo',
				bankCd: 'bankCd',
			},
			searchFunction: async (code: string) => {
				const bankacctResponse = await getBankacctList(code);
				return bankacctResponse.data.data.find(
					value => value.bankAcctNo === code || value.bankAcctCd === code
				);
			},
			extraFilter: () => ({
				bankAcctNo: editPUR6010_R01?.bankAcctNo || '',
				bankCd: editPUR6010_R01?.bankCd || '',
				compCd: editPUR6010_R01?.compCd || '',
			}),
		}
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: editPUR6010_R01,
		setEditData: setEditPUR6010_R01,
		defaultData: defaultPUR6010_R01HeaderRow,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PUR6010_R01'
	});

	// 거래일자 달력 팝업 상태
	const [paymentDtPickerVisible, setpaymentDtPickerVisible] = useState(false);
	const [paymentDtPickerPos, setpaymentDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});
	const [issueDtPickerVisible, setIssueDtPickerVisible] = useState(false);
	const [issueDtPickerPos, setIssueDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});
	const [dueDtPickerVisible, setDueDtPickerVisible] = useState(false);
	const [dueDtPickerPos, setDueDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	const calcPaymentAmt = (data: Partial<PUR6010_R01HeaderDto>) => (
		Number(data.cashAmt ?? 0) +
		Number(data.bankbookAmt ?? 0) +
		Number(data.noteAmt ?? 0) +
		Number(data.dcAmt ?? 0) +
		Number(data.advancesFee ?? 0) +
		Number(data.cmsAmt ?? 0)
	);

	const amountFieldNames = ['cashAmt', 'bankbookAmt', 'noteAmt', 'dcAmt', 'advancesFee', 'cmsAmt'] as const;

	const handleDateChange = useCallback((field: keyof PUR6010_R01HeaderDto, value: any) => {
		setEditPUR6010_R01({ ...defaultPUR6010_R01HeaderRow, ...editPUR6010_R01, [field]: value })
	}, [editPUR6010_R01])

	const handleChange = useCallback((e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;

		const nextData: PUR6010_R01HeaderDto = {
			...defaultPUR6010_R01HeaderRow,
			...editPUR6010_R01!,
			[name]: amountFieldNames.includes(name as typeof amountFieldNames[number])
				? Number(value) || 0
				: value,
		};

		if (amountFieldNames.includes(name as typeof amountFieldNames[number])) {
			nextData.paymentAmt = calcPaymentAmt(nextData);
			nextData.tradeAmt = nextData.paymentAmt;
		}

		setEditPUR6010_R01(nextData);
	}, [editPUR6010_R01, defaultPUR6010_R01HeaderRow, setEditPUR6010_R01]);

	// 등록 모드에서 거래처(customCd) 변경 시 detailCreateTrigger 설정
	// Content에서 detailCreateTrigger가 true일 때 fetchCreateDetailList 실행
	// useEffect(() => {
	// 	const customCd = editPUR6010_R01?.customCd || '';

	// 	if (selectedPUR6010_R01) {
	// 		prevCustomCdRef.current = customCd;
	// 		return;
	// 	}

	// 	if (!customCd) {
	// 		prevCustomCdRef.current = '';
	// 		return;
	// 	}

	// 	if (customCd === prevCustomCdRef.current) return;

	// 	prevCustomCdRef.current = customCd;
	// 	setDetailCreateTrigger(true);
	// }, [editPUR6010_R01?.customCd, selectedPUR6010_R01, setDetailCreateTrigger]);

	return (
		<div className="w-full h-full flex flex-col gap-[4px]">
			<div className="w-full h-full flex flex-wrap content-start pt-[12px] pl-[12px] pr-[12px] pb-[6px] overflow-y-auto border border-gray-300">

				<InputForm
					title="지불No."
					value={editPUR6010_R01?.tradeNo ?? ''}
					editable={false}
					name="tradeNo"
					onChange={handleChange} />
				<BRDiv />

				<DropDownForm
					title="사업장"
					name="compCd"
					initLabelLess={true}
					value={editPUR6010_R01?.compCd}
					data={compCdList}
					editable={true}
					onChange={handleChange}
				/>
				<SingleDateForm
					title="지불일자"
					value={editPUR6010_R01?.paymentDt ? new Date(editPUR6010_R01.paymentDt) : new Date()}
					setValue={(value: Date | undefined) => handleDateChange('paymentDt', formatDate(value))}
					editable={true}
					visible={paymentDtPickerVisible}				setVisible={setpaymentDtPickerVisible}
					onChange={handleChange}
					pickerPos={paymentDtPickerPos}						setPickerPos={setpaymentDtPickerPos}
				/>
				<BRDiv />

				<CodeForm
					label="거래처"
					value={editPUR6010_R01?.customCd || ""}
					custNmValue={editPUR6010_R01?.customNm || ""}
					editable={true}
					handleFoucsId={custInfoHandleFoucsId}
					name="customCd"
					handleChange={getFieldHandlers('customCd').onChange}
					onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
					onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
				/>
				<CodeForm
					label="지불담당"
					value={editPUR6010_R01?.empNo || ""}
					custNmValue={editPUR6010_R01?.empNm || ""}
					editable={true}
					handleFoucsId={empInfoHandleFoucsId}
					name="empNo"
					handleChange={getFieldHandlers('empNo').onChange}
					onDoubleClick={getFieldHandlers('empNo').onDoubleClick}
					onKeyDown={getFieldHandlers('empNo').onEnterKeyDown}
				/>
				<InputForm
					title="지불합계"
					value={editPUR6010_R01?.paymentAmt ?? 0}
					editable={false}
					name="paymentAmt"
					onChange={handleChange} />
				<BRDiv />

				<InputForm
					title="현금"
					value={editPUR6010_R01?.cashAmt ?? 0}
					editable={true}
					name="cashAmt"
					onChange={handleChange} />
				<InputForm
					title="계좌이체"
					value={editPUR6010_R01?.bankbookAmt ?? 0}
					editable={true}
					name="bankbookAmt"
					onChange={handleChange} />
				<DropDownForm
					title="지급은행"
					name="bankCd"
					initLabelLess={true}
					value={editPUR6010_R01?.bankCd}
					data={bankCdList}
					editable={true}
					onChange={handleChange}
				/>
				<InputForm
					title="지급계좌"
					value={editPUR6010_R01?.bankAcctNo ?? ''}
					editable={true}
					name="bankAcctNo"
					onChange={handleChange} />
				<BRDiv />

				<InputForm
					title="어음입금"
					value={editPUR6010_R01?.noteAmt ?? 0}
					editable={true}
					name="noteAmt"
					onChange={handleChange} />
				<InputForm
					title="어음번호"
					value={editPUR6010_R01?.noteNo ?? ""}
					editable={true}
					name="noteNo"
					onChange={handleChange} />
				<InputForm
					title="발행자"
					value={editPUR6010_R01?.publisher ?? ""}
					editable={true}
					name="publisher"
					onChange={handleChange} />
				<BRDiv />

				<DropDownForm
					title="발행은행"
					name="noteBankCd"
					initLabelLess={true}
					value={editPUR6010_R01?.noteBankCd}
					data={bankCdList}
					editable={true}
					onChange={handleChange}
				/>
				<RadioButtonForm
					title="자타수"
					titleValueMap={noteCreateFlgMap_PUR6010_R01}
					value={editPUR6010_R01?.noteCreateFlg ?? ''}
					name="noteCreateFlg"
					editable={true}
					onChange={handleChange}
					wrapperOption = {{
						wrapperStyle: "w-[300px] min-w-[300px] mr-[10px] mb-[5px]",
						titleStyle: "w-[100px] min-w-[100px] text-left",
						inputStyle: "mr-[5px]",
						radioStyle: "w-[97px] min-w-[97px]"
					}} 
				/>
				<InputForm
					title="배서회수"
					value={editPUR6010_R01?.endorseCnt ?? 0}
					editable={true}
					name="endorseCnt"
					onChange={handleChange}
				/>
				<BRDiv />

				<SingleDateForm
					title="발행일"
					value={editPUR6010_R01?.issueDt ? new Date(editPUR6010_R01.issueDt) : new Date()}
					setValue={(value: Date | undefined) => handleDateChange('issueDt', formatDate(value))}
					editable={true}
					visible={issueDtPickerVisible}				setVisible={setIssueDtPickerVisible}
					onChange={handleChange}
					pickerPos={issueDtPickerPos}						setPickerPos={setIssueDtPickerPos}
				/>				
				<SingleDateForm
					title="만기일"
					value={editPUR6010_R01?.dueDt ? new Date(editPUR6010_R01.dueDt) : new Date()}
					setValue={(value: Date | undefined) => handleDateChange('dueDt', formatDate(value))}
					editable={true}
					visible={dueDtPickerVisible}				setVisible={setDueDtPickerVisible}
					onChange={handleChange}
					pickerPos={dueDtPickerPos}						setPickerPos={setDueDtPickerPos}
				/>
				<BRDiv />

				<InputForm
					title="지불할인"
					value={editPUR6010_R01?.dcAmt ?? 0}
					editable={true}
					name="dcAmt"
					onChange={handleChange} />
				<InputForm
					title="선급금액"
					value={editPUR6010_R01?.advancesFee ?? 0}
					editable={true}
					name="advancesFee"
					onChange={handleChange} />
				<InputForm
					title="CMS"
					value={editPUR6010_R01?.cmsAmt ?? 0}
					editable={true}
					name="cmsAmt"
					onChange={handleChange} />
				<BRDiv />

				<InputForm
					title="비고"
					value={editPUR6010_R01?.remark || ""}
					editable={true}
					name="remark"
					wrapperOption={{
						wrapperStyle: "w-[510px] min-w-[510px] mr-[10px] mb-[10px]",
						titleStyle: "w-[100px] min-w-[100px] text-left",
						inputStyle: "w-full min-w-full"
					}}
					onChange={handleChange}
				/>
			</div>
		</div>
	)
}